import { LoadingButton } from "@mui/lab";
import { Box, Container, Paper } from "@mui/material";
import { useContent } from "../../content/useContent";

import Layout from "../Layout";
import Loading from "../Loading";
import Title from "../Title";

type IProps = {
  title: string;
  pageLoading: any;
  formik: any;
  submitLoading: any;
  width?: any;
  id?: any;
  children: any;
};

const classes = {
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    flexDirection: "column",
    pt: 10,
    pb: 5,
  },
  flexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
};

const Form: React.FC<IProps> = ({
  title,
  pageLoading,
  formik,
  submitLoading,
  width = "50%",
  id,
  children,
}) => {
  const { general } = useContent();
  return (
    <Layout>
      <Container sx={classes.center}>
        <Title
          variant="h5"
          title={`${id ? general.edit : general.add} ${title}`}
        />
        <Paper elevation={3} sx={{ p: 3, width, minWidth: "300px" }}>
          <Box
            component="form"
            sx={{ width: "100%" }}
            noValidate
            autoComplete="off"
          >
            {pageLoading ? (
              <Loading />
            ) : (
              <>
                {children}

                <Box sx={classes.flexEnd}>
                  <LoadingButton
                    onClick={formik.handleSubmit}
                    loading={submitLoading}
                    variant="contained"
                    sx={{ width: "100%", py: 1, mt: 2 }}
                  >
                    {`${id ? general.save : general.addNew} ${title}`}
                  </LoadingButton>
                </Box>
              </>
            )}
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default Form;
